import {
  addNewValueToAttribute,
  fetchAttributeValues
} from "@/modules/offers/api/productModeration"
import type { FindOrCreateAttributeValueParams } from "@/modules/offers/types/createOffer"
import type {
  AttributeValuesQuery,
  CreateAttributeValuePayload,
  CreateAttributeValueResponse
} from "@/modules/offers/types/productModeration"

export const findOrCreateAttributeValue = async ({
  attributeCode,
  attributeValueType,
  formValues
}: FindOrCreateAttributeValueParams): Promise<CreateAttributeValueResponse> => {
  const queryParams: AttributeValuesQuery & { code: string } = {
    code: attributeCode,
    value_str_contains:
      attributeValueType === "STRING" ? formValues.value_mlang.uk : formValues.value.toString()
  }

  if (attributeValueType === "NUMERIC") {
    queryParams.unit = formValues.unit || null
  }

  const pageSize = 10
  let page = 1

  while (true) {
    const { data } = await fetchAttributeValues({
      queryParams: { ...queryParams, page, pageSize }
    })
    const existingValue = data.results.find((item) => {
      if (attributeValueType === "STRING") {
        return item.value_mlang?.uk === formValues.value_mlang.uk && !item.unit
      }

      return (
        item.value === formValues.value && (item.unit?.oid || null) === (formValues.unit || null)
      )
    })

    if (existingValue) return existingValue

    if (page * pageSize >= data.count) break

    page += 1
  }

  const payload: CreateAttributeValuePayload =
    attributeValueType === "STRING"
      ? { value_mlang: { ...formValues.value_mlang } }
      : { value: formValues.value, unit: formValues.unit || null }
  const { data } = await addNewValueToAttribute({ code: attributeCode, payload })
  return data
}
